import orm from 'models'
import { createSelector as ormSelector } from 'redux-orm'
import { createSelector } from "reselect";
import getEntities from 'selectors/entities'
import isUuid from "../../is_uuid";
import { getScopeAttributes } from "../scoped_entities";

export const getTemplates = (kind) => {

  return ormSelector(orm, getEntities, (session) => {
    return session.template.filter(template => template.kind === kind).toModelArray().map(template => {
      const { ref } = template
      return { ...ref,
        ...getScopeAttributes(template.scopeId, template.scopeType, session)
      }
    })
  })
}

export const getSavedTemplates = (kind) => {
  return createSelector([getTemplates(kind)], (templates) => {
    return templates.filter(template => {
      return !isUuid(template.id)
    })
  })
}
